/**
 * @file 论坛专用文件上传tinymce插件
 * @author FranckChen(chenfan02@baidu.com)
 */

import $ from 'jquery';
import tinymce from 'tinymce';

import toast from '@/utils/decorate/toast';
import uploadImg from '../utils/uploadImg';

// 最大图片内容
const MAX_SIZE = 1024 * 1024 * 4;

tinymce.PluginManager.add('forumImgUpload', function (editor) {
    const uploader = $('<input type="file" style="display: none" />').appendTo($('body'));

    editor.addButton('forumImgUpload', {
        icon: 'image',
        onclick() {
            uploader.click();
        }
    });

    uploader.on('change', function (e) {
        // 判断上传文件是否图片
        if (!/image\/(png|bmp|gif|jpeg)$/.test(e.target.files[0].type)) {
            toast.error('图片格式不正确，请重新提交');
            return;
        }

        if (e.target.files[0].size > MAX_SIZE) {
            // 用来处理图片大于4M
            toast.info('您的图片超过4M，请重新提交');
            return;
        }

        // 添加上传提示
        editor.execCommand(
            'mceInsertContent',
            false,
            '<p class="loading" style="color: #999;">图片上传中，请耐心等待...</p>'
        );

        uploadImg(e.target.files[0])
            .then(data => {
                // 移除上传提示
                $(editor.dom.doc).find('.loading').remove();


                // 在光标位置插入图片
                editor.execCommand(
                    'mceInsertContent',
                    false,
                    `<img class="upload-img" alt="默认图片" src="https://${data.imageUrl}" />`
                );
            })
            .catch(errmsg => {
                $(editor.dom.doc).find('.loading').remove();
                // $(editor.dom.doc).find('.upload-img').remove();
                toast.error(errmsg);
            });

        // 清空属性，才能在选择同一路径文件时触发change事件
        e.target.value = '';
    });
});
